import { render, staticRenderFns } from "./purchase-product-edit-modal.vue?vue&type=template&id=baf79a40&"
import script from "./purchase-product-edit-modal.vue?vue&type=script&lang=js&"
export * from "./purchase-product-edit-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "purchase-product-edit-modal.vue"
export default component.exports